import { useAdvancedSearch } from "@/context/advanced-search/AdvancedSearchContext";
import { Badge } from "../ui/badge";
import { XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const AdvancedSearchChip = () => {
  const advancedSearch = useAdvancedSearch();

  const { t } = useTranslation();

  return (
    <>
      {advancedSearch.advancedSearchQuery && (
        <Badge
          className="flex flex-row gap-2 items-center cursor-pointer"
          variant={"draft"}
          onClick={() => advancedSearch.resetQuery()}
        >
          {advancedSearch.advancedSearchQuery.name
            ? advancedSearch.advancedSearchQuery.name
            : t("advancedSearchWithoutName")}

          <XIcon className="size-3" />
        </Badge>
      )}
    </>
  );
};
